import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import React, { useEffect, useState, useMemo } from 'react'
import { getLeads } from '../logic/leads/action'
import { useDispatch, useSelector } from 'react-redux'
import { MdArrowBackIos, MdArrowForwardIos, MdClose, MdMoreVert } from 'react-icons/md'
import InputComponents from './input'
import { Debouncer } from '../utils/debouncer'
import { useNavigate } from 'react-router-dom'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const debouncer = new Debouncer(300);

const LeadsComponent = ({open,setClose}) => {
    const dispatch = useDispatch();
    const leadsState = useSelector(state=>state.leads);
    useEffect(() => {
      getLeads(dispatch);
    }, []);

    const [patientData, setpatientData] = useState(null);

    // console.log(leadsState?.leads);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const nav = useNavigate();
    
  return (
    <Dialog open={open} fullWidth>
        <IconButton onClick={setClose} sx={{position:'absolute',top:2,right:2}}>
            <MdClose/>
        </IconButton>
        <DialogTitle>
            <Box display={'flex'} alignItems={'center'} gap={2}>
                <Typography>Leads</Typography>
                <div className='w-60'>
                <InputComponents 
                onChange={(ev)=>{
                    // debouncer.debounce(()=>{
                        getLeads(dispatch,ev.target.value);
                    // });
                }}
                    placeholder='Search by name or number'
                />
                </div>
            </Box>
        </DialogTitle>
        <DialogContent>
            <div className="ag-theme-alpine" style={{ height: '400px', width: '100%' }}>
                <AgGridReact
                    rowData={leadsState?.leads?.leads || []}
                    columnDefs={useMemo(() => [
                        {
                            field: 'full_name',
                            headerName: 'Name',
                            flex: 1,
                            minWidth: 150
                        },
                        {
                            field: 'contact',
                            headerName: 'Phone',
                            flex: 1,
                            minWidth: 150
                        },
                        {
                            field: 'actions',
                            headerName: 'Actions',
                            width: 100,
                            cellRenderer: (params) => {
                                return (
                                    <IconButton size="small" onClick={(ev) => {
                                        setpatientData(params.data);
                                        handleClick(ev);
                                    }}>
                                        <MdMoreVert/>
                                    </IconButton>
                                );
                            },
                            sortable: false,
                            filter: false
                        }
                    ], [])}
                    defaultColDef={useMemo(() => ({
                        sortable: true,
                        filter: true,
                        resizable: true
                    }), [])}
                    pagination={false}
                    animateRows={true}
                />
            </div>
            <div className='w-full flex justify-end gap-2 items-center pt-2'>
                <IconButton disabled={!Boolean(leadsState?.leads?.page) || leadsState?.leads?.page <= 2 } onClick={()=>{
                    getLeads(dispatch,'',leadsState?.leads?.page-2)
                }}>
                    <MdArrowBackIos/>
                </IconButton>
                <p>{(!Boolean(leadsState?.leads?.page) || leadsState?.leads?.page <= 1)? 1: leadsState?.leads?.page - 1}</p>
                <IconButton disabled={!Boolean(leadsState?.leads?.page)} onClick={()=>{
                    getLeads(dispatch,'',leadsState?.leads?.page)
                }}>
                    <MdArrowForwardIos/>
                </IconButton>
            </div>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openMenu}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            // nav("/admin/service");
          }}
        >
        Book Appointment
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            // nav("/admin/service");
          }}
        >
            <a href={`tel:${patientData?.contact}`}>
          Call Patient
            </a>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            // nav("/admin/service");
          }}
        >
            <a href={`sms:${patientData?.contact}`}>
          Text Patient
            </a>
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={() => {
            // nav("/admin/service");
          }}
        >
            <a href={`whatsapp://send?phone=${patientData?.contact}`}>
            Whatsapp Patient
            </a>
        </MenuItem>
      </Menu>
        </DialogContent>
    </Dialog>
  )
}

export default LeadsComponent